import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'language',
    cache: {
        ttl: 15000
    }
})
export class LanguageStore extends BaseStore {
    constructor() {
        super();
    }
}
